/**
 * API payloads often expose each dimension (bias, abuse_ai, fairness_metric, …) as an array of
 * runs. Prefer the run with the newest `timestamp` instead of assuming index 0 is current.
 */
export function pickLatestCollectionRun<T>(v: T | T[] | null | undefined): T | null {
  if (v == null) return null;
  if (!Array.isArray(v)) return v;
  if (v.length === 0) return null;

  type Scored = { item: T; ts: number; idx: number };
  const scored: Scored[] = v.map((item, idx) => {
    const raw = (item as { timestamp?: unknown })?.timestamp;
    const ts = typeof raw === 'string' && raw.length > 0 ? Date.parse(raw) : Number.NaN;
    return { item, ts: Number.isFinite(ts) ? ts : Number.NaN, idx };
  });

  const valid = scored.filter(s => !Number.isNaN(s.ts));
  if (valid.length > 0) {
    valid.sort((a, b) => b.ts - a.ts || b.idx - a.idx);
    return valid[0].item;
  }

  return v[v.length - 1] ?? null;
}
